import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiPlus, FiMinus } from "react-icons/fi";
import { IoChevronBackOutline } from "react-icons/io5";

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();

  const faqs = [
    {
      category: "Pool Management",
      items: [
        { question: "How do I create a new pool?", answer: "Head to the Dashboard or Pools tab and hit '+ New Pool'. Pick a tournament, set your team size, and you're off to the races (well, the fairways)." },
        { question: "How do I invite friends?", answer: "Open your pool, click 'Manage', then 'Invite Players'. Enter their name and email -- they'll get a link to pick their team. No account needed on their end. You can also copy the link directly to text or WhatsApp it." },
        { question: "How do I mark a team as paid?", answer: "Go to your pool, click 'Manage', then 'Manage Entries'. Toggle the paid checkbox next to each person. Simple as a tap-in." },
        { question: "What happens if I change the tournament?", answer: "All existing team selections get cleared since each tournament has a different player field. Everyone will need to re-pick their teams." },
      ],
    },
    {
      category: "Team Management",
      items: [
        { question: "How do I pick my team?", answer: "Click the link from your invite email or go to your team page. Select your players from the dropdown and hit Save. You can update your picks anytime before the tournament starts." },
        { question: "Why can't I edit my team?", answer: "Teams lock when the tournament begins. Once the first tee time passes, all teams are final. Choose wisely before then!" },
        { question: "Do I need an account to pick my team?", answer: "Nope! Just use the link from your invite email. No account, no password, no hassle." },
      ],
    },
    {
      category: "Scoring & Leaderboard",
      items: [
        { question: "How does scoring work?", answer: "Your team's score is based on your selected golfers' tournament performance. The pool owner sets how many players count toward scoring and whether all must make the cut." },
        { question: "When do leaderboards update?", answer: "Leaderboards update automatically during the tournament. Scores refresh every few minutes so you can watch the drama unfold in near real-time." },
        { question: "Can anyone see the leaderboard?", answer: "Yes! The pool owner can share a public leaderboard link that anyone can view -- no login required. Perfect for the group chat." },
      ],
    },
    {
      category: "App Tips",
      items: [
        { question: "How do I add this to my home screen?", answer: "On your phone's browser, tap the share/menu button and select 'Add to Home Screen'. You'll get an app icon for quick access to check scores on the go." },
        { question: "How do I share the leaderboard?", answer: "Open your pool and click 'Share Leaderboard'. This copies a public link anyone can view without logging in." },
      ],
    },
  ];

  const toggleQuestion = (categoryIndex, questionIndex) => {
    const key = `${categoryIndex}-${questionIndex}`;
    setOpenIndex(openIndex === key ? null : key);
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-6 md:pt-20 mb-24 md:mb-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-primary to-primary-light rounded-2xl p-6 mb-6 shadow-lg">
        <div className="flex items-center gap-3">
          <button onClick={() => navigate(-1)} className="text-green-200 hover:text-white transition-colors">
            <IoChevronBackOutline className="w-5 h-5" />
          </button>
          <div>
            <h1 className="text-2xl font-bold text-white tracking-tight">FAQs</h1>
            <p className="text-sm text-green-200 mt-0.5">Everything you need to know about GolfPools</p>
          </div>
        </div>
      </div>

      <div className="space-y-6">
        {faqs.map((category, categoryIndex) => (
          <div key={categoryIndex}>
            <h2 className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-3 px-1">{category.category}</h2>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden divide-y divide-gray-50">
              {category.items.map((faq, questionIndex) => {
                const key = `${categoryIndex}-${questionIndex}`;
                const isOpen = openIndex === key;

                return (
                  <div key={questionIndex}>
                    <button
                      onClick={() => toggleQuestion(categoryIndex, questionIndex)}
                      className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-gray-50 transition-colors"
                    >
                      <span className="text-sm font-medium text-gray-900 pr-4">{faq.question}</span>
                      {isOpen
                        ? <FiMinus className="w-5 h-5 text-primary flex-shrink-0" />
                        : <FiPlus className="w-5 h-5 text-gray-400 flex-shrink-0" />
                      }
                    </button>
                    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96" : "max-h-0"}`}>
                      <p className="px-5 pb-4 text-sm text-gray-600 leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default FAQ;
